import axiosClassic from 'axios';
import { session } from '../session/constants'

const handleAxiosResponse = async (config) => {
    const results = { response: null, error: null };

    try {
        const res = await axiosClassic(config.url, config);
        
        if(res?.data?.status === 'Token is Expired'){
            results.error = res;
            localStorage.clear();
            sessionStorage.setItem(session.SESSION_STATE, session.SESSION_OFF);
            sessionStorage.removeItem(session.SESSION_ID_USER);
            sessionStorage.removeItem(session.SESSION_TYPE_USER);
            sessionStorage.removeItem(session.SESSION_TOKEN);
            window.location.href = '/';
        }else{
            results.response = res;
        }
        
    } catch (error) {
        results.error = error;
        const { data } = error.response;

        if (data?.data?.status === 'Token is Expired') {
            localStorage.clear();
            sessionStorage.setItem(session.SESSION_STATE, session.SESSION_OFF);
            sessionStorage.removeItem(session.SESSION_ID_USER);
            sessionStorage.removeItem(session.SESSION_TYPE_USER);
            sessionStorage.removeItem(session.SESSION_TOKEN);
            window.location.href = '/';
        }
    }

    return new Promise((resolve, reject) => {
        if(results.response) 
            resolve(results.response);

        if(results.error) 
            reject(results.error);
    });
}

class CustomAxios {
    get(url, config){
        return handleAxiosResponse({
            ...config,
            url,
            method: 'get'
        });
    }

    post(url, data, config){
        return handleAxiosResponse({
            ...config,
            url,
            data,
            method: 'post'
        });
    }

    put(url, data, config){
        return handleAxiosResponse({
            ...config,
            url,
            data,
            method: 'put'
        });
    }

    options(url, config){
        return handleAxiosResponse({
            ...config,
            url,
            method: 'options'
        });
    }

    patch(url, data, config){
        return handleAxiosResponse({
            ...config,
            url,
            data,
            method: 'patch'
        });
    }

    delete(url, config){
        return handleAxiosResponse({
            ...config,
            url,
            method: 'delete'
        });
    }

    head(url, config){
        return handleAxiosResponse({
            ...config,
            url,
            method: 'head'
        });
    }

    request(config){
        return handleAxiosResponse({
            ...config
        });
    }
}


export default new CustomAxios()